import React, {Fragment} from "react";
import {
    CrownOutlined,
    SkinOutlined,
    UserOutlined,
    ManOutlined,
    WomanOutlined,
    CloudOutlined,
    FolderOutlined
} from "@ant-design/icons";
import {Space} from "antd";


export default function ContactIcon({contact}) {
    //console.log("ICON FOR",contact)

    if (!contact) {
        return <UserOutlined/>
    }

    var icon = null
    var sexeIcon = null
    var deceasedIcon=null
    var archivedIcon=null

    if(contact.archived){
        archivedIcon=<FolderOutlined/>
    }

    if(contact.deceased){
        deceasedIcon=<CloudOutlined />
    }

    if (Array.isArray(contact.parents) && contact.parents.length > 0) {
        icon = <SkinOutlined/>
    }
    if (contact.chef) {
        icon = <CrownOutlined/>
    }

    if (contact.homme === true) {
        sexeIcon = <ManOutlined/>
    }

    if (contact.homme === false) {
        sexeIcon = <WomanOutlined/>
    }

    if(!icon && !sexeIcon && !deceasedIcon){
        return(
            <span className={"mr-1"}>
                {archivedIcon && archivedIcon}
                <UserOutlined/>
            </span>
        )
    }

    return(
        <span className={"mr-1"}>
            {archivedIcon && archivedIcon}
            {deceasedIcon && deceasedIcon}
            {sexeIcon && sexeIcon}
            {icon && icon}
        </span>
    )
}
